export const makeUuid = (defaultUuid: number = 1): string =>
  `${defaultUuid++}-${new Date().toISOString()}`;
